import qs from "query-string";
import { Badge } from "reactstrap";
import classnames from "classnames";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { useDispatch } from "react-redux";
import { toggleActivity } from "@store/reducers/app";

const VerticalNavMenuLink = ({ item, activeItem }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  // ** Conditional Link Tag, if item has newTab or externalLink props use <a> tag else use NavLink
  const LinkTag = item.externalLink ? "a" : NavLink;

  return (
    <li
      className={classnames({
        "nav-item": !item.children,
        disabled: item.disabled,
        active: item.navLink === activeItem,
        hidden: item.requires && !(item.requires.every((key) => {
          return Object.keys(qs.parse(location.search)).includes(key);
          })
        ),
      })}
    >
      <LinkTag
        className='d-flex align-items-center'
        target={item.newTab ? "_blank" : undefined}
        /*eslint-disable */
        {...(item.externalLink === true
          ? {
              href: item.navLink || '/'
            }
          : {
              to: `${item.navLink}${location.search}` || '/',
                className: ({ isActive }) => {
                if (isActive && !item.disabled) {
                  return 'd-flex align-items-center active'
                }
              }
            })}
        onClick={e => {
          if (item.externalLink === true) {
            dispatch(
              toggleActivity({
                type: "navigate",
                action: item.id,
              })
            )
          }

          if (item.navLink.length === 0 || item.navLink === '#' || item.disabled === true) {
            e.preventDefault()
          }
        }}
      >
        {item.icon}
        <span className='menu-item text-truncate'>{item.title}</span>

        {item.badge && item.badgeText ? (
          <Badge className='ms-auto me-1' color={item.badge} pill>
            {item.badgeText}
          </Badge>
        ) : null}
      </LinkTag>
    </li>
  )
}

export default VerticalNavMenuLink
